import { Component, OnInit } from '@angular/core';
import { SideBarService } from '../shared/sidebar/sidebar.service';

@Component({
  selector: 'ls-iphone',
  templateUrl: './iphone.component.html'
})
export class IphoneComponent implements OnInit {
  constructor(private sideBarService: SideBarService) {}

  public ngOnInit(): void {
    this.sideBarService.close();
  }
}
